import { render, staticRenderFns } from "./AdministrationOption.vue?vue&type=template&id=dd38d5f2&scoped=true"
import script from "./AdministrationOption.vue?vue&type=script&lang=js"
export * from "./AdministrationOption.vue?vue&type=script&lang=js"
import style0 from "./AdministrationOption.vue?vue&type=style&index=0&id=dd38d5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd38d5f2",
  null
  
)

export default component.exports